import { Navigate, useLocation } from "react-router";
import { useAuth } from "./AuthProvider";
import { appUrl } from "../lib/customerUrl";

/**
 * Legacy /dashboard, /account, /settings and /billing links never carried
 * the customer slug. Redirect to the canonical /apps/crm/{orgSlug}/... URL,
 * preserving ?search (or forcing a ?tab=, for the old /billing shortcut).
 */
export function TenantRedirect({ to, tab }: { to: string; tab?: string }) {
  const { session } = useAuth();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (tab) params.set("tab", tab);
  const search = params.toString();
  const target = appUrl("crm", session?.orgSlug, to);
  return <Navigate to={search ? `${target}?${search}` : target} replace />;
}
